export default class extends Controller {
  displayLongRequestWarning() {
    App.Helpers.appendContent(this.element, this.warning);
  }

  get warning() {
    return `
      <div class="long-request-warning">
        <h1>Your Patience is Appreciated</h1>
        <p>Uploading data may take up to a few minutes, depending on file size.</p>
        ${App.spinner()}
      </div>
    `;
  }
};



// WEBPACK FOOTER //
// ./app/components/imports/assets/javascript/imports-form-controller.js